<template>
  <div
    id="author-detail"
    :class="{
      'author-detail-mobile': !isDesktop,
      'author-detail-desktop': isDesktop,
      'mobile-detail-from-author': newsDetailOpenedFromAuthor,
    }"
  >
    <vs-sidebar
      hidden-background
      v-model="active"
      position-right
      spacer
      class="items-no-padding"
    >
      <feather-icon
        icon="XIcon"
        @click.stop="onClose"
        class="cursor-pointer close-icon-custom"
      ></feather-icon>
      <!-- <vs-divider class="mt-10 mb-5" /> -->
      <div class="content text-center content-autor" v-if="isAuthenticated">
        <vs-avatar
          v-if="author.image_path"
          size="100px"
          :src="author.image_path"
        />
        <vs-avatar
          v-if="!author.image_path"
          size="100px"
          :src="avatarDefault"
        />
        <div v-if="author.name">
          <h3>{{ author.name }}</h3>
        </div>
        <div v-if="author.email">
          <span class="author-email">{{ author.email }}</span>
          <!-- <a href="mailto:@"> {{ author.email }}</a> -->
        </div>
        <div class="flex items-center"></div>
        <vs-row>
          <!-- <vs-row vs-w="12" class="mt-5" >
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12" >
            <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-twitter"></vs-button>

          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-facebook"></vs-button>

          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-instagram"></vs-button>

          </vs-col>
        </vs-row> -->
        </vs-row>
        <div v-if="author.resume" class="mt-5 mb-5">{{ author.resume }}</div>

        <div class="my-2 text-left">
          <span>{{ $t("AUTHOR_DETAIL").Publication }}</span>
        </div>

        <div class="flex">
          <vx-card title="" class="mb-base h-full">
            <div class="truncate">
              <h2 class="mb-1 font-bold">{{ author.totalSent }}</h2>
              <span>{{ $t("AUTHOR_DETAIL").Total }}</span>
            </div>
          </vx-card>
          <vx-card title="" class="mb-base h-full">
            <div class="truncate">
              <h2 class="mb-1 font-bold">{{ author.todaySent }}</h2>
              <span>{{ $t("AUTHOR_DETAIL").Today }}</span>
            </div>
          </vx-card>
        </div>
      </div>
      <template>
        <div class="last-sent-list">
          <custom-content
            class="mt-3 mobile"
            v-if="!isAuthenticated"
            :isDesktop="isDesktop"
            :displayCloseBtn="false"
            @open-register="openRegister"
          />
          <!-- <private-content-reduced
            v-if="!isAuthenticated"
            :isDesktop="isDesktop"
            :displayCloseBtn="false"
            @open-register="openRegister"
          ></private-content-reduced> -->
          <div
            class="lbl-home p-1 pl-3 bold"
            v-if="lastSent.length > 0 && isAuthenticated"
          >
            {{ $t("AUTHOR_DETAIL").Last_Sent }}
          </div>
          <div
            v-if="lastSent.length > 0 && isAuthenticated"
            class="custom-author-detail-news-scroll"
          >
            <!-- :settings="settings"
            ref="mailListPS"
            :suppressScrollX="true" -->
            <transition-group
              name="list-enter-up"
              class="email__mails"
              tag="ul"
              appear
            >
              <li
                class="cursor-pointer email__mail-item list-auth"
                v-for="(item, index) in lastSent"
                :key="index + 1"
                @click.stop="openDetail(item)"
              >
                <informative-list-item
                  :data="item"
                  :isDesktop="isDesktop"
                  :currentCommodity="currentCommodity"
                  :contentId="item.newsContent[0].code"
                  :isAuthenticated="isAuthenticated"
                  :fromAuthorDetail="true"
                />
              </li>
            </transition-group>
          </div>
        </div>
      </template>
      <!-- <template v-if="!isAuthenticated">
        <custom-content
          :isDesktop="isDesktop"
          :displayCloseBtn="false"
          @open-register="openRegister"
        />
      </template> -->
      <div
        v-if="!isDesktop"
        class="v-nav-menu-swipe-area"
        v-hammer:swipe.right="onClose"
      ></div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { EventBus } from "../../../event-bus";
import AppConstants from "../../../appConstants";
import userService from "../../../providers/userService";
import InformativeListItem from "../../../views/pages/informative/InformativeListItem.vue";
import CustomContent from "../../../views/pages/CustomContent.vue";
import PrivateContentReduced from "../../../views/pages/private-content/PrivateContentReduced.vue";

export default {
  props: {
    isDesktop: {
      required: true,
    },
  },
  data() {
    return {
      active: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      title: "",
      author: {
        _id: "",
        name: "",
        email: "",
        resume: "",
        image_path: "",
        totalSent: 0,
        todaySent: 0,
      },
      lastSent: [],
      newsDetailOpenedFromAuthor: false,
    };
  },
  watch: {
    // active(val) {
    //   this.$store.dispatch('updatePlaylistOpen', val);
    // },
  },
  computed: {
    avatarDefault() {
      return require("@/assets/images/portrait/small/avatar-default.jpg");
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL, (val) => {
      // console.log('[authorDetail] ', val)
      if (val) {
        this.active = true;
        this.author._id = val._id;
        this.author.name = val.name;
        this.author.email = val.email;
        this.author.resume = val.resume;
        this.author.image_path = val.image_path;
        if (this.isAuthenticated) {
          this.getUserCountSentNews();
        }
      } else {
        this.active = false;
        this.author._id = "";
        this.author.name = "";
        this.author.email = "";
        this.author.resume = "";
        this.author.image_path = "";
        this.author.totalSent = 0;
        this.author.todaySent = 0;
      }
    });
    if (this.$store.state.insetTop || this.$store.state.insetBottom) {
      let styleTag = document.getElementById(
        "autor-detail-sidebar-inset-overrides"
      );
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "autor-detail-sidebar-inset-overrides";
        document.head.appendChild(styleTag);
      }
      styleTag.textContent = `
      #author-detail .vs-sidebar{
        top: ${this.$store.state.insetTop}px !important;
        bottom: ${this.$store.state.insetBottom}px !important;
        height: auto !important;
        max-height: 100% !important;
      }

    `;
    }
  },
  destroyed() {
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL);
  },
  methods: {
    onClose() {
      this.active = false;
      this.newsDetailOpenedFromAuthor = false;
    },
    openRegister() {
      this.active = false;
      setTimeout(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REGISTER);
      }, 200);
    },
    openDetail(item) {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REPORT_DETAIL, item);
      if (this.isDesktop) {
        this.onClose();
      } else {
        this.newsDetailOpenedFromAuthor = true;
      }
    },
    getUserCountSentNews() {
      const params = new URLSearchParams();
      if (this.author._id) {
        params.append("userId", this.author._id);
      } else {
        params.append("email", this.author.email);
      }
      params.append("isAuthenticated", this.isAuthenticated);
      userService
        .getUserCountSentNews(params)
        .then((res) => {
          this.author.totalSent = res.total;
          this.author.todaySent = res.today;
          this.lastSent = res.lastSent;
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    VuePerfectScrollbar,
    InformativeListItem,
    CustomContent,
    PrivateContentReduced,
  },
};
</script>

<style lang="scss">
#author-detail .vs-sidebar {
  position: fixed;
  z-index: 52000;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
  background: #fff;
}
.author-detail-desktop .vs-sidebar {
  width: 400px;
  max-width: 90vw;
  // @apply shadow-lg;
}
span.cursor-pointer.close-icon-customizer.feather-icon.select-none.relative {
  z-index: 999999;
  box-shadow: #ccc 0px 1px 3px;
  position: absolute;
  left: 15px;
  top: 15px;
  width: 24px;
  height: 24px;
  border-radius: 20px;
  border-width: 1px;
  border-color: #ddd;
}
span.cursor-pointer.close-icon-customizer.feather-icon.select-none.relative:hover {
  background-color: #ddd;
}
span.cursor-pointer.close-icon-customizer.feather-icon.select-none.relative
  svg {
  margin-top: 0px;
  margin-left: 3px;
  margin-right: 3px;
}
.content-autor {
  text-align: center !important;
  margin: 30px;
  line-height: 24px;
}
</style>
